var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"40px","display":"flex","align-items":"center"}},[_c('div',{staticClass:"work_title_color"}),_c('span',{staticClass:"work_title"},[_vm._v(" 订单近30天数量统计 ")])]),_c('div',{staticClass:"statisticChart"})])
}]

export { render, staticRenderFns }